import { render, staticRenderFns } from "./JournalCOAImport.vue?vue&type=template&id=aeda6788"
import script from "./JournalCOAImport.vue?vue&type=script&lang=js"
export * from "./JournalCOAImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports